import { render, staticRenderFns } from "./EstatisticaHabilitacoes.vue?vue&type=template&id=d0644f46"
import script from "./EstatisticaHabilitacoes.vue?vue&type=script&lang=js"
export * from "./EstatisticaHabilitacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports